import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NgxPaginationModule, PaginatePipe } from 'ngx-pagination';
import { PaginationComponent } from './pagination.component';

@NgModule({
    declarations: [PaginationComponent],
    exports: [PaginationComponent],
    imports: [CommonModule, NgxPaginationModule],
    providers: [PaginatePipe]
})
export class PaginationModule {}
